import { SegmentoJustica } from './../models/segmento-justica.enum';
import { Injectable } from '@angular/core';
import { Natureza } from './../models/natureza.enum';
import { NivelSigilo } from './../models/nivel-sigilo.enum';
import { PermissaoAbrangencia, PermissaoOrigem } from './../usuario-permissao/usuario-permissao.model';
import { SelectItem } from 'primeng/api/selectitem';
import {
  FonteDadosInstancia,
  SistemaProcessual,
  TipoFonteDados,
  TipoSistemaProcessual,
} from '../fonte-dados/fonte-dados.model';
import { MensagemControleSituacao } from '../mensagem-controle/mensagem-controle-situacao.model';
import { Agrupamento } from '../models/agrupamento.enum';
import { AtribuicaoPeticaoInicial } from '../models/atribuicao-peticao-Inicial';
import { Instancia } from '../models/instancia.enum';
import { TipoProcessoDocumentoVisibilidade } from '../models/tipo-processo-documento-visibilidade.enum';
import { PeticaoInicialFiltro } from '../models/peticao-inicial-filtro.enum ';
import { SituacaoAnalise } from '../models/situacao-analise.enum';
import { Situacao } from '../models/situacao.enum';
import { TipoJustica } from '../models/tipo-justica.enum';
import { TipoValor } from '../models/tipo-valor.enum';
import { SituacaoProcessamento } from './../fonte-dados/item-processamento.model';
import { ParametroNomeMicroServicoVersao } from './../models/fonte-dados-versao-detalhes';
import { TipoExemplo } from './../models/tipo-exemplo.enum';
import { ParametroVersao } from './../parametro/parametro.model';
import { PessoaAuditoriaAcessoComponente } from '../models/pessoa-auditoria-acesso-componente.enum';
import { ProcessoAuditoriaAcessoComponente } from '../models/processo-auditoria-acesso-componente.enum';
import { RecursoSegurancaDominio } from '../models/recurso-seguranca-dominio.enum';
import { RecursoSegurancaMetodo } from '../models/recurso-seguranca-metodo.enum';
import { LimiteNivelSigilo } from '../models/limite-nivel-sigilo.enum';
import { TipoUsuario } from '../models/tipo-usuario.enum';
import { TipoPessoa } from '../models/tipo-pessoa.enum';
import { PartesSituacao } from '../models/partes-situacao.enum';
import { ProcessoTipoRelacionamento } from '../processo-relacionamento/processo-relacionamento.model';
import { PartePolo } from '../models/parte-polo.enum';
import { TipoArquivo } from '../models/tipo-arquivo.enum';
import { ClasseGrupoProcedimentoEnum } from '../models/classe-grupo-procedimento.enum';
import { ClasseTipoProcedimentoEnum } from '../models/classe-tipo-procedimento.enum';
import { SituacaoIndicadorProcessamento } from '../models/situacaoIndicadorProcessamento.enum';
import {
  ProcessoIdentificacaoPeticaoInicialSituacao,
} from '../processo-identificacao-peticao-inicial/processo-identificacao-peticao-inicial-situacao.enum';
import {
  ProcessoIdentificacaoPeticaoInicialModo,
} from '../processo-identificacao-peticao-inicial/processo-identificacao-peticao-inicial-modo.enum';

import { SituacaoMigracaoEnum } from '../models/situacao-migracao.enum';
import { FonteDadosComunicacaoSituacao } from '../enums/fonte-dados-comunicacao-situacao';
import { TipoIndisponibilidade } from '../indisponibilidade/tipo-indisponibilidade.enum';
import { PessoaOutroNomeTipo } from '../models/pessoa-outro-nome-tipo.enum';
import { PessoaTipoRelacionamento } from '../models/pessoa-tipo-relacionamento.enum';
import { PessoaTelefoneTipo } from '../models/pessoa-telefone-tipo.enum';
import { PessoaEnderecoEletronicoTipo } from '../models/pessoa-endereco-eletronico-tipo.enum';
import { PessoaDocumentoTipo } from '../models/pessoa-documento-tipo.enum';
import { JurisdicaoLocalAbrangencia } from '../models/jurisdicao-local-abrangencia.enum';
import { CategoriaTipoComplemento } from '../models/categoria-tipo-complemento.enum';

@Injectable()
export class SelectItemService {

  public getLabel(itens: SelectItem[], value: any): string {
    const itensComValor = itens.filter(i => i.value === value);
    return itensComValor.length > 0 ? itensComValor[0].label : value.toString();
  }

  public getSituacaoProcessamentoItens(): any {
    return [
      { label: 'Pendente', value: SituacaoProcessamento.PENDENTE },
      { label: 'Processado', value: SituacaoProcessamento.PROCESSADO },
      { label: 'Falha no processamento', value: SituacaoProcessamento.FALHA_PROCESSAMENTO },
      { label: 'Inapto', value: SituacaoProcessamento.INAPTO }
    ];
  }

  public getInstanciaItens(): SelectItem[] {
    return [
      { label: 'Primeiro grau', value: Instancia.PRIMEIRO_GRAU },
      { label: 'Segundo grau', value: Instancia.SEGUNDO_GRAU },
      { label: 'Terceiro grau', value: Instancia.TERCEIRO_GRAU },
      { label: 'Quarto grau', value: Instancia.QUARTO_GRAU },
    ];
  }

  public getVisibilidadeItens(): SelectItem[] {
    return [
      { label: 'Público', value: TipoProcessoDocumentoVisibilidade.PUBLICO },
      { label: 'Restrito', value: TipoProcessoDocumentoVisibilidade.RESTRITO },
    ];
  }

  public getFonteDadosInstanciaItens(): SelectItem[] {
    return [
      { label: 'Primeiro grau', value: FonteDadosInstancia.PRIMEIRO_GRAU },
      { label: 'Segundo grau', value: FonteDadosInstancia.SEGUNDO_GRAU },
      { label: 'Terceiro grau', value: FonteDadosInstancia.TERCEIRO_GRAU },
      { label: 'Quarto grau', value: FonteDadosInstancia.QUARTO_GRAU },
      { label: 'Misto', value: FonteDadosInstancia.MISTO },
    ];
  }

  public getTipoValorItens(): SelectItem[] {
    return [
      { label: 'Unitário', value: TipoValor.UNITARIO },
      { label: 'Multivalorado', value: TipoValor.MULTIVALORADO },
    ];
  }

  public getTipoExemploItens(): SelectItem[] {
    return [
      { label: 'Positivo', value: TipoExemplo.POSITIVO },
      { label: 'Negativo', value: TipoExemplo.NEGATIVO },
    ];
  }

  public getSituacaoItens(): SelectItem[] {
    return [
      { label: 'Ativo', value: Situacao.ATIVO },
      { label: 'Inativo', value: Situacao.INATIVO },
    ];
  }

  public getSimNaoItens(): SelectItem[] {
    return [
      { label: 'Sim', value: true },
      { label: 'Não', value: false },
    ];
  }

  public getMensagemControleSituacaoItens(): SelectItem[] {
    return [
      { label: 'Não processada', value: MensagemControleSituacao.NAO_PROCESSADA },
      { label: 'Falha no processamento', value: MensagemControleSituacao.FALHA_PROCESSAMENTO },
      { label: 'Quarentena', value: MensagemControleSituacao.QUARENTENA },
      { label: 'Suspensa', value: MensagemControleSituacao.SUSPENSA }
    ];
  }

  public getTipoJusticaItens(): SelectItem[] {
    return [
      { label: 'Ambas', value: TipoJustica.AMBAS },
      { label: 'Indefinido', value: TipoJustica.INDEFINIDO },
      { label: 'Especial', value: TipoJustica.ESPECIAL },
      { label: 'Comum', value: TipoJustica.COMUM }
    ];
  }

  public getNaturezaItens(): SelectItem[] {
    return [
      { label: 'Genérica', value: Natureza.GENERICA },
      { label: 'Indefinida', value: Natureza.INDEFINIDA },
      { label: 'Cível', value: Natureza.CIVEL },
      { label: 'Criminal', value: Natureza.CRIMINAL },
      { label: 'Trabalhista', value: Natureza.TRABALHISTA },
      { label: 'Eleitoral', value: Natureza.ELEITORAL },
      { label: 'Militar', value: Natureza.MILITAR },
      { label: 'Fiscal', value: Natureza.FISCAL }
    ];
  }

  public getAgrupamentoItens(): SelectItem[] {
    return [
      { label: 'Hora', value: Agrupamento.HORA },
      { label: 'Dia', value: Agrupamento.DIA },
    ];
  }

  public getSegmentoJusticaItens(): SelectItem[] {
    return [
      { label: 'Supremo Tribunal Federal', value: SegmentoJustica.SUPREMO_TRIBUNAL_FEDERAL },
      { label: 'Conselho Nacional de Justiça', value: SegmentoJustica.CONSELHO_NACIONAL_JUSTICA },
      { label: 'Superior Tribunal de Justiça', value: SegmentoJustica.SUPERIOR_TRIBUNAL_JUSTICA },
      { label: 'Justiça Federal', value: SegmentoJustica.JUSTICA_FEDERAL },
      { label: 'Justiça Estadual', value: SegmentoJustica.JUSTICA_ESTADUAL },
      { label: 'Justiça do Trabalho', value: SegmentoJustica.JUSTICA_TRABALHO },
      { label: 'Justiça Eleitoral', value: SegmentoJustica.JUSTICA_ELEITORAL },
      { label: 'Justiça Militar da União', value: SegmentoJustica.JUSTICA_MILITAR_UNIAO },
      { label: 'Justiça Militar Estadual', value: SegmentoJustica.JUSTICA_MILITAR_ESTADUAL },
    ];
  }

  public getFiltroPeticaoInicial(): SelectItem[] {
    return [
      { label: 'Todos', value: PeticaoInicialFiltro.TODOS },
      { label: 'Com Petição Inicial Associada', value: PeticaoInicialFiltro.COM_PETICAO_INICIAL },
      { label: 'Sem Petição Inicial Associada', value: PeticaoInicialFiltro.SEM_PETICAO_INICIAL }
    ];
  }

  public getAtribuicaoDePeticaoInicial(): SelectItem[] {
    return [
      { label: 'Definida', value: AtribuicaoPeticaoInicial.DEFINIDA },
      { label: 'Pendente', value: AtribuicaoPeticaoInicial.PENDENTE },
    ];
  }

  public getSituacaoAnalise(): SelectItem[] {
    return [
      { label: 'Analisada', value: SituacaoAnalise.ANALISADA },
      { label: 'Pendente', value: SituacaoAnalise.PENDENTE },
      { label: 'Ambas', value: SituacaoAnalise.AMBAS },
    ];
  }

  public getTipoFonteDados(): SelectItem[] {
    return [
      { label: 'Extrator', value: TipoFonteDados.EXTRATOR },
      { label: 'Integração', value: TipoFonteDados.INTEGRACAO },
    ];
  }

  public getSistemaProcessual(): SelectItem[] {
    return [
      { label: 'PJe', value: SistemaProcessual.PJE },
      { label: 'PJE_JT', value: SistemaProcessual.PJE_JT },
      { label: 'PJE_JE', value: SistemaProcessual.PJE_JE },
      { label: 'PJE_1X', value: SistemaProcessual.PJE_1X },
      { label: 'Projudi', value: SistemaProcessual.PROJUDI },
      { label: 'SAJ', value: SistemaProcessual.SAJ },
      { label: 'EPROC', value: SistemaProcessual.EPROC },
      { label: 'Apolo', value: SistemaProcessual.APOLO },
      { label: 'Themis', value: SistemaProcessual.THEMIS },
      { label: 'Libra', value: SistemaProcessual.LIBRA },
      { label: 'SCPv', value: SistemaProcessual.SCPV },
      { label: 'DCP', value: SistemaProcessual.DCP },
      { label: 'eJUD', value: SistemaProcessual.EJUD },
      { label: 'Tucujuris', value: SistemaProcessual.TUCUJURIS },
      { label: 'SIAJ', value: SistemaProcessual.SIAJ },
      { label: 'Outros', value: SistemaProcessual.OUTROS },
    ];
  }

  public getTipoSistemaProcessual(): SelectItem[] {
    return [
      { label: 'Sistema Eletrônico', value: TipoSistemaProcessual.ELETRONICO },
      { label: 'Sistema Físico', value: TipoSistemaProcessual.FISICO },
      { label: 'Sistema Híbrido', value: TipoSistemaProcessual.HIBRIDO },
    ];
  }

  public getLimiteNivelSigiloItens(): SelectItem[] {
    return [
      { label: 'Nenhum', value: LimiteNivelSigilo.NENHUM },
      { label: 'Público', value: LimiteNivelSigilo.PUBLICO },
      { label: 'Segredo de Justiça', value: LimiteNivelSigilo.SEGREDO_JUSTICA },
      { label: 'Sigilo Mínimo', value: LimiteNivelSigilo.SIGILO_MINIMO },
      { label: 'Sigilo Médio', value: LimiteNivelSigilo.SIGILO_MEDIO },
      { label: 'Sigilo Intenso', value: LimiteNivelSigilo.SIGILO_INTENSO },
      { label: 'Sigilo Absoluto', value: LimiteNivelSigilo.SIGILO_ABSOLUTO },
    ];
  }

  public getOrigemItens(): SelectItem[] {
    return [
      { label: 'Nativo', value: PermissaoOrigem.NATIVO },
      { label: 'Corporativo', value: PermissaoOrigem.CORPORATIVO },
    ];
  }

  public getPermissaoAbrangenciaItens(): SelectItem[] {
    return [
      { label: 'Nacional', value: PermissaoAbrangencia.NACIONAL },
      { label: 'Órgão de justiça', value: PermissaoAbrangencia.ORGAO_JUSTICA },
      { label: 'Fonte de dados', value: PermissaoAbrangencia.FONTE_DADOS },
      { label: 'Órgão julgador colegiado', value: PermissaoAbrangencia.ORGAO_JULGADOR_COLEGIADO },
      { label: 'Órgão julgador', value: PermissaoAbrangencia.ORGAO_JULGADOR }
    ];
  }

  public getBooleanoSimNaoItens(): SelectItem[] {
    return [
      { label: 'Sim', value: true },
      { label: 'Não', value: false }
    ];
  }

  public getParametroItens(): SelectItem[] {
    return [
      { label: 'Conversor', value: ParametroVersao.CONVERSOR },
      { label: 'Extrator', value: ParametroVersao.EXTRATOR },
      { label: 'Iris', value: ParametroVersao.IRIS },
      { label: 'Prisma', value: ParametroVersao.PRISMA }
    ];
  }

  public getParametroVersaoDetalhesItens(): SelectItem[] {
    return [
      { label: 'ultimaVersaoConversor', value: ParametroNomeMicroServicoVersao.ULTIMA_VERSAO_CONVERSOR },
      { label: 'ultimaVersaoExtrator', value: ParametroNomeMicroServicoVersao.ULTIMA_VERSAO_EXTRATOR },
      { label: 'ultimaVersaoIris', value: ParametroNomeMicroServicoVersao.ULTIMA_VERSAO_IRIS },
      { label: 'ultimaVersaoPrisma', value: ParametroNomeMicroServicoVersao.ULTIMA_VERSAO_PRISMA }
    ];
  }

  public getPessoaAuditoriaAcessoComponenteItens(): SelectItem[] {
    return [
      {label: 'Documentos', value: PessoaAuditoriaAcessoComponente.DOCUMENTOS },
      {label: 'Endereços', value: PessoaAuditoriaAcessoComponente.ENDERECOS },
      {label: 'Genitores', value: PessoaAuditoriaAcessoComponente.GENITORES },
      {label: 'Metadados', value: PessoaAuditoriaAcessoComponente.METADADOS },
      {label: 'Outros nomes', value: PessoaAuditoriaAcessoComponente.OUTROS_NOMES },
      {label: 'Endereços eletrônicos', value: PessoaAuditoriaAcessoComponente.ENDERECOS_ELETRONICOS },
      {label: 'Telefones', value: PessoaAuditoriaAcessoComponente.TELEFONES},
      {label: 'Relacionamentos', value: PessoaAuditoriaAcessoComponente.RELACIONAMENTOS },
      {label: 'Graphql', value: PessoaAuditoriaAcessoComponente.GRAPHQL }
    ];
  }

  public getProcessoAuditoriaAcessoComponenteItens(): SelectItem[] {
    return [
      {label: 'Documento', value: ProcessoAuditoriaAcessoComponente.DOCUMENTOS},
      {label: 'Documento conteúdo', value: ProcessoAuditoriaAcessoComponente.DOCUMENTO_CONTEUDO},
      {label: 'Documento texto', value: ProcessoAuditoriaAcessoComponente.DOCUMENTO_TEXTO},
      {label: 'Metadados', value: ProcessoAuditoriaAcessoComponente.METADADOS},
      {label: 'Movimentos', value: ProcessoAuditoriaAcessoComponente.MOVIMENTOS},
      {label: 'Partes', value: ProcessoAuditoriaAcessoComponente.PARTES},
      {label: 'Assuntos', value: ProcessoAuditoriaAcessoComponente.ASSUNTOS},
      {label: 'Classes', value: ProcessoAuditoriaAcessoComponente.CLASSES},
      {label: 'Completo', value: ProcessoAuditoriaAcessoComponente.COMPLETO},
      {label: 'Distribuições', value: ProcessoAuditoriaAcessoComponente.DISTRIBUICOES},
      {label: 'Documentos Metadados', value: ProcessoAuditoriaAcessoComponente.DOCUMENTO_METADADOS},
      {label: 'Identificação Petição Inicial', value: ProcessoAuditoriaAcessoComponente.IDENTIFICACAO_PETICAO_INICIAL},
      {label: 'Relacionamentos', value: ProcessoAuditoriaAcessoComponente.RELACIONAMENTOS},
      {label: 'GraphQL', value: ProcessoAuditoriaAcessoComponente.GRAPHQL}
    ];
  }

  public getTiposUsuarios(): SelectItem[] {
    return [
      { label: 'Pessoa', value: TipoUsuario.PESSOA },
      { label: 'Extrator', value: TipoUsuario.EXTRATOR },
      { label: 'Sistema', value: TipoUsuario.SISTEMA }
    ];
  }

  public getDominios(): SelectItem[] {
    return [
      { label: 'Backend', value: RecursoSegurancaDominio.BACKEND },
      { label: 'Frontend', value: RecursoSegurancaDominio.FRONTEND },
    ];
  }

  public getMetodos(): SelectItem[] {
    return [
      { label: 'TODOS', value: RecursoSegurancaMetodo.TODOS },
      { label: 'POST', value: RecursoSegurancaMetodo.POST },
      { label: 'GET', value: RecursoSegurancaMetodo.GET},
      { label: 'PUT', value: RecursoSegurancaMetodo.PUT },
      { label: 'DELETE', value: RecursoSegurancaMetodo.DELETE },
      { label: 'PATCH', value: RecursoSegurancaMetodo.PATCH },
    ];
  }

  public getTipoPessoa(): SelectItem[] {
    return [
      { label: 'Física', value: TipoPessoa.FISICA },
      { label: 'Jurídica', value: TipoPessoa.JURIDICA },
      { label: 'Autoridade', value: TipoPessoa.AUTORIDADE },
    ];
  }

  public getPartesSituacao(): SelectItem[] {
    return [
      { label: 'Ativo', value: PartesSituacao.ATIVO },
      { label: 'Inativo', value: PartesSituacao.INATIVO },
      { label: 'Suspenso', value: PartesSituacao.SUSPENSO },
      { label: 'BAIXADO', value: PartesSituacao.BAIXADO },
    ];
  }

  public getPolos(): SelectItem[] {
    return [
      { label: 'Ativo', value: PartePolo.ATIVO },
      { label: 'Passivo', value: PartePolo.PASSIVO },
      { label: 'Terceiro', value: PartePolo.TERCEIRO },
      { label: 'Fiscal lei', value: PartePolo.FISCAL_LEI },
      { label: 'Testemunha juízo', value: PartePolo.TESTEMUNHA_JUIZO },
      { label: 'Amicus curae', value: PartePolo.ASSISTENTE_DESINTERESSADO_AMICUS_CURAE },
      { label: 'Vítima', value: PartePolo.VITIMA },
      { label: 'Outros participantes', value: PartePolo.OUTROS_PARTICIPANTES },
      { label: 'Não vinculados', value: PartePolo.NAO_VINCULADOS },
    ];
  }

  public getRelacionamentoTipo(): SelectItem[] {
    return [
      { label: 'Apenso', value: ProcessoTipoRelacionamento.APENSO},
      { label: 'Ação Rescisória', value: ProcessoTipoRelacionamento.ACAO_RESCISORIA },
      { label: 'Competência Delegada', value: ProcessoTipoRelacionamento.COMPETENCIA_DELEGADA },
      { label: 'Continência', value: ProcessoTipoRelacionamento.CONTINENCIA },
      { label: 'Conexão', value: ProcessoTipoRelacionamento.CONEXAO },
      { label: 'Dependência', value: ProcessoTipoRelacionamento.DEPENDENCIA },
      { label: 'Desmembramento', value: ProcessoTipoRelacionamento.DESMEMBRAMENTO },
      { label: 'Incidental', value: ProcessoTipoRelacionamento.INCIDENTAL },
      { label: 'Originário', value: ProcessoTipoRelacionamento.ORIGINARIO },
      { label: 'Outro Tipo Associação', value: ProcessoTipoRelacionamento.OUTRO_TIPO_ASSOCIACAO },
      { label: 'Processo Referência', value: ProcessoTipoRelacionamento.PROCESSO_REFERENCIA },
      { label: 'Prevenção', value: ProcessoTipoRelacionamento.PREVENCAO },
      { label: 'Precedente de Uniformização', value: ProcessoTipoRelacionamento.PRECEDENTE_DE_UNIFORMIZACAO },
      { label: 'Repercussão Geral', value: ProcessoTipoRelacionamento.REPERCUSSAO_GERAL },
      { label: 'Recurso Repetitivo', value: ProcessoTipoRelacionamento.RECURSO_REPETITIVO },
      { label: 'Traslado', value: ProcessoTipoRelacionamento.TRASLADO },
      { label: 'Vinculação Indireta', value: ProcessoTipoRelacionamento.VINCULACAO_INDIRETA },
    ];
  }

  public getTipoArquivo(): SelectItem[] {
    return [
      { label: 'TXT', value: TipoArquivo.TEXT_PLAIN },
      { label: 'HTML', value: TipoArquivo.TEXT_HTML },
      { label: 'RTF', value: TipoArquivo.TEXT_RICHTEXT },
      { label: 'PDF', value: TipoArquivo.APPLICATION_PDF },
      { label: 'ODT', value: TipoArquivo.APPLICATION_ODT },
      { label: 'DOC', value: TipoArquivo.APPLICATION_DOC },
      { label: 'DOCX', value: TipoArquivo.APPLICATION_DOCX },
      { label: 'KML', value: TipoArquivo.APPLICATION_KML },
      { label: 'PNG', value: TipoArquivo.IMAGE_PNG },
      { label: 'BMP', value: TipoArquivo.IMAGE_BMP },
      { label: 'JPEG', value: TipoArquivo.IMAGE_JPEG },
      { label: 'GIF', value: TipoArquivo.IMAGE_GIF },
      { label: 'TIFF', value: TipoArquivo.IMAGE_TIFF },
      { label: 'SVG', value: TipoArquivo.IMAGE_SVG_XML },
      { label: 'Não identificado', value: TipoArquivo.NAO_IDENTIFICADO }
    ];
  }

  public getGrupoProcedimento(): SelectItem[] {
    return [
      { label: 'Indefinido', value: ClasseGrupoProcedimentoEnum.INDEFINIDO },
      { label: 'Outros', value: ClasseGrupoProcedimentoEnum.OUTROS },
      { label: 'Conhecimento', value: ClasseGrupoProcedimentoEnum.CONHECIMENTO },
      { label: 'Execução Judicial', value: ClasseGrupoProcedimentoEnum.EXECUCAO_JUDICIAL },
      { label: 'Execução Título Extrajudicial', value: ClasseGrupoProcedimentoEnum.EXECUCAO_TITULO_EXTRAJUDICIAL },
      { label: 'Incidente à Execução', value: ClasseGrupoProcedimentoEnum.INCIDENTE_EXECUCAO },
      { label: 'Carta', value: ClasseGrupoProcedimentoEnum.CARTA },
      { label: 'Procedimento Investigatório', value: ClasseGrupoProcedimentoEnum.PROCEDIMENTO_INVESTIGATORIO },
      { label: 'Variável (Incidente à Execução OU Outros)', value: ClasseGrupoProcedimentoEnum.VARIAVEL },
      { label: 'Administrativo Eleitoral', value: ClasseGrupoProcedimentoEnum.ADMINISTRATIVO_ELEITORAL }
    ];
  }

  public getTipoProcedimento(): SelectItem[] {
    return [
      { label: 'Administrativo', value: ClasseTipoProcedimentoEnum.ADMINISTRATIVO },
      { label: 'Administrativo Disciplinar', value: ClasseTipoProcedimentoEnum.ADMINISTRATIVO_DISCIPLINAR },
      { label: 'Administrativo Eleitoral', value: ClasseTipoProcedimentoEnum.ADMINISTRATIVO_ELEITORAL },
      { label: 'Ato ou Expediente', value: ClasseTipoProcedimentoEnum.ATO_EXPEDIENTE },
      { label: 'Carta', value: ClasseTipoProcedimentoEnum.CARTA },
      { label: 'Cautelar', value: ClasseTipoProcedimentoEnum.CAUTELAR },
      { label: 'Conhecimento', value: ClasseTipoProcedimentoEnum.CONHECIMENTO },
      { label: 'Constitucional', value: ClasseTipoProcedimentoEnum.CONSTITUCIONAL },
      { label: 'Consulta', value: ClasseTipoProcedimentoEnum.CONSULTA },
      { label: 'Cumprimento de Sentença/Decisão', value: ClasseTipoProcedimentoEnum.CUMPRIMENTO_SENTENCA_DECISAO },
      { label: 'Diversos', value: ClasseTipoProcedimentoEnum.DIVERSOS },
      { label: 'Embargos à Execusão', value: ClasseTipoProcedimentoEnum.EMBARGOS_EXECUCAO },
      { label: 'Execução Fiscal', value: ClasseTipoProcedimentoEnum.EXECUCAO_FISCAL },
      { label: 'Execução Judicial', value: ClasseTipoProcedimentoEnum.EXECUCAO_JUDICIAL },
      { label: 'Execução de Título Extrajudicial', value: ClasseTipoProcedimentoEnum.EXECUCAO_TITULO_EXTRAJUDICIAL },
      { label: 'Extinto', value: ClasseTipoProcedimentoEnum.EXTINTO },
      { label: 'Incidente Administrativo', value: ClasseTipoProcedimentoEnum.INCIDENTE_ADMINITRATIVO },
      { label: 'Incidente ao Cumprimento de Sentença/Decisão', value: ClasseTipoProcedimentoEnum.INCIDENTE_CUMPRIMENTO_SENTENCA_DECISAO },
      { label: 'Incidente Especial', value: ClasseTipoProcedimentoEnum.INCIDENTE_ESPECIAL },
      { label: 'Incidente à Execução', value: ClasseTipoProcedimentoEnum.INCIDENTE_EXECUCAO },
      { label: 'Incidente à Execução em Mandado de Segurança', value: ClasseTipoProcedimentoEnum.INCIDENTE_EXECUCAO_MANDADO_SEGURANCA },
      { label: 'Incidente à Execução Penal', value: ClasseTipoProcedimentoEnum.INCIDENTE_EXECUCAO_PENAL },
      { label: 'Incidente Geral', value: ClasseTipoProcedimentoEnum.INCIDENTE_GERAL },
      { label: 'Indefinido', value: ClasseTipoProcedimentoEnum.INDEFINIDO },
      { label: 'Liquidação', value: ClasseTipoProcedimentoEnum.LIQUIDACAO },
      { label: 'Medida Garantidora', value: ClasseTipoProcedimentoEnum.MEDIDA_GARANTIDORA },
      { label: 'Medida Preparatória', value: ClasseTipoProcedimentoEnum.MEDIDA_PREPARATORIA },
      { label: 'Outro', value: ClasseTipoProcedimentoEnum.OUTRO },
      { label: 'Pré-Processual', value: ClasseTipoProcedimentoEnum.PRE_PROCESSUAL },
      { label: 'Procedimento Investigatório', value: ClasseTipoProcedimentoEnum.PROCESIMENTO_INVESTIGATORIO },
      { label: 'Reclamação', value: ClasseTipoProcedimentoEnum.RECLAMACAO },
      { label: 'Recurso Administrativo', value: ClasseTipoProcedimentoEnum.RECURSO_ADMINISTRATIVO },
      { label: 'Recurso Administrativo Disciplinar', value: ClasseTipoProcedimentoEnum.RECURSO_ADMINISTRATIVO_DISCIPLINAR },
      { label: 'Recurso de Cautelar', value: ClasseTipoProcedimentoEnum.RECURSO_CAUTELAR },
      { label: 'Recurso de Conhecimento', value: ClasseTipoProcedimentoEnum.RECURSO_CONHECIMENTO },
      { label: 'Recurso Interno de Cautelar', value: ClasseTipoProcedimentoEnum.RECURSO_INTERNO_CAUTELAR },
      { label: 'Recurso Interno de Conhecimento', value: ClasseTipoProcedimentoEnum.RECURSO_INTERNO_CONHECIMENTO },
      { label: 'Recurso Interno à Execução', value: ClasseTipoProcedimentoEnum.RECURSO_INTERNO_EXECUCAO },
      { label: 'Recurso de Medida Garantidora', value: ClasseTipoProcedimentoEnum.RECURSO_MEDIDA_GARANTIDORA },
      { label: 'Recurso em Outra Instância', value: ClasseTipoProcedimentoEnum.RECURSO_OUTRA_INSTANCIA },
      { label: 'Restauração', value: ClasseTipoProcedimentoEnum.RESTAURACAO },
      { label: 'Súmula', value: ClasseTipoProcedimentoEnum.SUMULA },
      { label: 'Suspensão', value: ClasseTipoProcedimentoEnum.SUSPENSAO },
      { label: 'Tutela Antecedente', value: ClasseTipoProcedimentoEnum.TUTELA_ANTECEDENTE }
    ];
  }

  public getSituacaoIndicadorProcessamento(): SelectItem[] {
    return [
      { label: 'Em execução', value: SituacaoIndicadorProcessamento.EM_EXECUCAO },
      { label: 'Falha Processamento', value: SituacaoIndicadorProcessamento.FALHA_PROCESSAMENTO },
      { label: 'Processado', value: SituacaoIndicadorProcessamento.PROCESSADO },
    ];
  }

  public getSituacaoMigracaoItens(): SelectItem[] {
    return [
      { label: 'Nativo', value: SituacaoMigracaoEnum.NATIVO },
      { label: 'Emigrante', value: SituacaoMigracaoEnum.EMIGRANTE },
      { label: 'Imigrante', value: SituacaoMigracaoEnum.IMIGRANTE },
    ];
  }
  public getProcessoIdentificacaoPeticaoInicialSituacao(): SelectItem[] {
    return [
      { label: 'Agendada', value: ProcessoIdentificacaoPeticaoInicialSituacao.AGENDADA },
      { label: 'Ausente', value: ProcessoIdentificacaoPeticaoInicialSituacao.AUSENTE },
      { label: 'Falha processamento', value: ProcessoIdentificacaoPeticaoInicialSituacao.FALHA_PROCESSAMENTO },
      { label: 'Identificada', value: ProcessoIdentificacaoPeticaoInicialSituacao.IDENTIFICADA },
      { label: 'Pendente', value: ProcessoIdentificacaoPeticaoInicialSituacao.PENDENTE }
    ];
  }

  public getProcessoIdentificacaoPeticaoInicialModo(): SelectItem[] {
    return [
      { label: 'Automático', value: ProcessoIdentificacaoPeticaoInicialModo.AUTOMATICO },
      { label: 'Manual', value: ProcessoIdentificacaoPeticaoInicialModo.MANUAL },
      { label: 'Nenhum', value: ProcessoIdentificacaoPeticaoInicialModo.NENHUM }
    ];
  }
  public getFonteDadosComunicacaoSituacao(): SelectItem[] {
    return [
      { label: 'Sucesso', value: FonteDadosComunicacaoSituacao.SUCESSO },
      { label: 'Falha', value: FonteDadosComunicacaoSituacao.FALHA }
    ];
  }
  public getNivelSigiloItens(): SelectItem[] {
    return [
      { label: 'Publico', value: NivelSigilo.PUBLICO },
      { label: 'Segredo de Justiça', value: NivelSigilo.SEGREDO_JUSTICA },
      { label: 'Sigilo Mínimo', value: NivelSigilo.SIGILO_MINIMO },
      { label: 'Sigilo Médio', value: NivelSigilo.SIGILO_MEDIO },
      { label: 'Sigilo Intenso', value: NivelSigilo.SIGILO_INTENSO },
      { label: 'Sigilo Absoluto', value: NivelSigilo.SIGILO_ABSOLUTO },
    ];
  }
  public getTipoIndisponibilidade(): SelectItem[] {
    return [
      { label: 'Parcial', value: TipoIndisponibilidade.PARCIAL },
      { label: 'Total', value: TipoIndisponibilidade.TOTAL }
    ];
  }

  public getPessoaOutroNomeTipo(): SelectItem[] {
    return [
      { label: 'Alcunha', value: PessoaOutroNomeTipo.ALCUNHA },
      { label: 'Nome Social', value: PessoaOutroNomeTipo.NOME_SOCIAL },
      { label: 'Outro', value: PessoaOutroNomeTipo.OUTRO }
    ];
  }

  public getPessoaRelacionamentoTipo (): SelectItem[] {
    return [
      { label: 'Assistência legal ascendente', value: PessoaTipoRelacionamento.ASSISTENCIA_LEGAL_ASCENDENTE },
      { label: 'Curador', value: PessoaTipoRelacionamento.CURADOR },
      { label: 'Outro', value: PessoaTipoRelacionamento.OUTRO },
      { label: 'Representação legal ascendente', value: PessoaTipoRelacionamento.REPRESENTACAO_LEGAL_ASCENDENTE },
      { label: 'Representado', value: PessoaTipoRelacionamento.REPRESENTADO },
      { label: 'Representante', value: PessoaTipoRelacionamento.REPRESENTANTE },
      { label: 'Substituição representação processual', value: PessoaTipoRelacionamento.SUBSTITUICAO_REPRESENTACAO_PROCESSUAL },
      { label: 'Sucessor', value: PessoaTipoRelacionamento.SUCESSOR },
      { label: 'Tutor', value: PessoaTipoRelacionamento.TUTOR },
      { label: 'Vínculo', value: PessoaTipoRelacionamento.VINCULO},
    ];
  }

  public getPessoaCelularTipo(): SelectItem[] {
    return [
      { label: 'Celular', value: PessoaTelefoneTipo.CELULAR },
      { label: 'Comercial', value: PessoaTelefoneTipo.COMERCIAL },
      { label: 'Fax', value: PessoaTelefoneTipo.FAX },
      { label: 'Outro', value: PessoaTelefoneTipo.OUTRO },
      { label: 'Residencial', value: PessoaTelefoneTipo.RESIDENCIAL },
      { label: 'Telegram', value: PessoaTelefoneTipo.TELEGRAM },
      { label: 'Whatsapp', value: PessoaTelefoneTipo.WHATSAPP }
    ];
  }

  public getPessoaEnderecoEletronicoTipo(): SelectItem[] {
    return [
      { label: 'E-mail', value: PessoaEnderecoEletronicoTipo.E_MAIL },
      { label: 'Facebook', value: PessoaEnderecoEletronicoTipo.FACEBOOK },
      { label: 'Instagram', value: PessoaEnderecoEletronicoTipo.INSTAGRAM },
      { label: 'Outro', value: PessoaEnderecoEletronicoTipo.OUTRO },
      { label: 'Site', value: PessoaEnderecoEletronicoTipo.SITE },
      { label: 'X - Twitter', value: PessoaEnderecoEletronicoTipo.TWITTER }
    ];
  }

  public getPessoaDocumentoTipo(): SelectItem[] {
    return [
      { label: 'CC', value: PessoaDocumentoTipo.CC },
      { label: 'CEI', value: PessoaDocumentoTipo.CEI },
      { label: 'CI', value: PessoaDocumentoTipo.CI },
      { label: 'CN', value: PessoaDocumentoTipo.CN },
      { label: 'CNH', value: PessoaDocumentoTipo.CNH },
      { label: 'CNPJ', value: PessoaDocumentoTipo.CNPJ },
      { label: 'CP', value: PessoaDocumentoTipo.CP },
      { label: 'CPF', value: PessoaDocumentoTipo.CPF },
      { label: 'CT', value: PessoaDocumentoTipo.CT },
      { label: 'IF', value: PessoaDocumentoTipo.IF },
      { label: 'NB', value: PessoaDocumentoTipo.NB },
      { label: 'NIT', value: PessoaDocumentoTipo.NIT },
      { label: 'OAB', value: PessoaDocumentoTipo.OAB },
      { label: 'PAS', value: PessoaDocumentoTipo.PAS },
      { label: 'PIS_PASEP', value: PessoaDocumentoTipo.PIS_PASEP },
      { label: 'RGE', value: PessoaDocumentoTipo.RGE },
      { label: 'RIC', value: PessoaDocumentoTipo.RIC },
      { label: 'RJC', value: PessoaDocumentoTipo.RJC },
      { label: 'RJI', value: PessoaDocumentoTipo.RJI },
      { label: 'TE', value: PessoaDocumentoTipo.TE },
      { label: 'OUTROS', value: PessoaDocumentoTipo.OUTROS }
    ];
  }

  public getJurisdicaolocalAbrangencia(): SelectItem[] {
    return [
      { label: 'Estadual', value: JurisdicaoLocalAbrangencia.ESTADUAL},
      { label: 'Localidade', value: JurisdicaoLocalAbrangencia.LOCALIDADE},
      { label: 'Nacional', value: JurisdicaoLocalAbrangencia.NACIONAL }
    ];
  }

  public getCategoriaTipoComplemento(): SelectItem[] {
    return [
      { label: 'Identificador', value: CategoriaTipoComplemento.IDENTIFICADOR},
      { label: 'Tabelado', value: CategoriaTipoComplemento.TABELADO },
      { label: 'Livre', value: CategoriaTipoComplemento.LIVRE }
    ];
  }
}
